// eslint-disable-next-line no-restricted-imports -- we need to use apollo-client for this error
import {ApolloError} from "apollo-client";

import {Errors, KAError} from "@khan/logging";

/**
 * An error from invoking a GraphQL query or mutate operation.
 */
export default class ApolloGqlError extends KAError {
    readonly _isNetworkError: boolean = false;

    /**
     * Construct a ApolloGqlError instance.
     *
     * @param {Error | string} errorMessageSource The error being wrapper or
     * reported. When this is the source error, the 2nd argument is ignored.
     * @param {Error} [sourceError] The Error instance that is the source of
     * the wrapped error. This is ignored if an Error instance is passed as the
     * `errorMessageSource` in the first argument.
     */
    constructor(
        errorMessageSource: Error | string,
        sourceError: Error | null = null,
    ) {
        if (typeof errorMessageSource === "string") {
            // @ts-expect-error - TS2401
            super(errorMessageSource, Errors.TransientKhanService, {
                cause: sourceError,
            });
            if (sourceError instanceof ApolloError) {
                this._isNetworkError = Boolean(sourceError.networkError);
            } else if (sourceError instanceof ApolloGqlError) {
                this._isNetworkError = sourceError._isNetworkError;
            }
        } else {
            super(errorMessageSource.message, Errors.TransientKhanService, {
                cause: errorMessageSource,
            });
            if (errorMessageSource instanceof ApolloError) {
                this._isNetworkError = Boolean(errorMessageSource.networkError);
            } else if (errorMessageSource instanceof ApolloGqlError) {
                this._isNetworkError = errorMessageSource._isNetworkError;
            }
        }

        this.name = `ApolloGqlError`;
    }

    get isNetworkError(): boolean {
        return this._isNetworkError;
    }
}
